/**
 * Gets the full title from the ContentByQuery JSON response data, which is located on the "TitleInfo" object as the "full_title" property.
 *
 * @export
 * @param {any} data The ContentByQuery JSON response data.
 * @returns The Full Book Title
 */
export function getFullTitle(data) {
	return (data && data.TitleInfo && data.TitleInfo.full_title) || "";
}


// WEBPACK FOOTER //
// ./src/data/FullTitleSelector.jsx